<template>
  <article>
    <ul
      class="c-education-info-data-info grid text-sm xl:text-base leading-tight grid-cols-2"
      :class="{ 'grid-cols-3': location, 'mb-3 md:mb-4 lg:mb-6': courseMaterial || isAvailable }"
    >
      <li v-if="duration">
        <h3 class="mb-1">{{ t_('duration') }}</h3>
        <p class="font-bold">{{ duration }}</p>
      </li>
      <li v-if="location">
        <h3 class="mb-1">{{ t_('location') }}</h3>
        <p class="font-bold">{{ location }}</p>
      </li>
      <li v-if="price">
        <h3 class="mb-1">{{ t_('price') }}</h3>
        <p class="font-bold">{{ price }}</p>
      </li>
    </ul>

    <div v-if="courseMaterial || isAvailable" class="flex gap-3 flex-col sm:flex-row lg:flex-col" :class="{ 'sm:inline-flex lg:flex': !courseMaterial || !isAvailable }">
      <MoleculeButton
        v-if="isAvailable"
        class="c-education-info-data-button"
        background-color="bg-black hover:bg-white lg:hover:bg-app-secondary-7-violet--purple-heart"
        text-color="hover:text-black lg:text-white lg:hover:text-white"
        :class="{ 'md:flex-1': courseMaterial }"
        @click="$emit('toggleModal')"
      >
        {{ t_('reserve-date-time') }}
      </MoleculeButton>

      <MoleculeButton
        v-if="courseMaterial"
        class="c-education-info-data-button md:flex-1"
        background-color="bg-white hover:bg-black lg:hover:bg-app-secondary-7-violet--purple-heart"
        text-color="text-black hover:text-white"
        url="#course-material"
        :enable-icon-left="false"
      >
        <AtomIconAppHat class="shrink-0 w-4 md:w-5 h-4 md:h-5 mr-2" />
        {{ t_('lesson-material') }}
      </MoleculeButton>
    </div>

    <div class="flex gap-1 w-full sm:gap-3" :class="{ 'sm:w-1/2 lg:w-full': !courseMaterial || !isAvailable }">
      <MoleculeButton
        v-if="isAvailable"
        size="medium"
        class="c-education-info-data-button-mobile-sticky self-stretch flex-1 hover:bg-app-secondary-7-violet--purple-heart"
        @click="$emit('toggleModal')"
      >
        {{ t_('reserve-date-time-mobile') }}
      </MoleculeButton>

      <MoleculeButton
        v-if="courseMaterial"
        class="c-education-info-data-button-mobile-sticky hover:bg-app-secondary-7-violet--purple-heart hover:text-white flex-1"
        background-color="bg-white"
        text-color="text-black"
        url="#course-material"
        :enable-icon-left="false"
        size="medium"
      >
        <AtomIconAppHat class="shrink-0 w-4 md:w-5 h-4 md:h-5 mr-2" />
        {{ t_('lesson-material') }}
      </MoleculeButton>
    </div>
  </article>
</template>

<script setup lang="ts">
defineProps({
  toggleModalVisible: { type: Function, required: false, default: undefined },
  location: { type: String, required: false, default: undefined },
  duration: { type: String, required: false, default: undefined },
  price: { type: String, required: false, default: undefined },
  isAvailable: { type: Boolean, required: false, default: true },
  courseMaterial: { type: Boolean, required: false, default: false },
})

defineEmits(['toggleModal'])

const { t_ } = setupTranslationPrefixer('EducationProductionPageInfoData')
</script>

<style lang="scss">
// scoped scss is not suitable for this component, it won't work in this case because it needs to inherit styles from parent elements
.c-education-info-data-button,
.c-education-info-data-status {
  .i-is-stuck-on-mobile & {
    @apply hidden;
  }
}

.c-education-info-data-info {
  .i-is-stuck-on-mobile & {
    @apply hidden;
  }
}

.c-education-info-data-button-mobile-sticky {
  @apply hidden;

  .i-is-stuck-on-mobile & {
    @apply flex;
  }
}

.c-education-info-available-from-sticky-desktop {
  @apply hidden;

  .i-is-stuck-on-desktop & {
    @apply block;
  }
}

.c-education-info-data-title {
  @apply hidden;

  .i-is-stuck-on-mobile & {
    @apply block mr-3;
  }

  .i-is-stuck-on-desktop & {
    @apply block mb-4;
  }
}
</style>
